<template>
  <component
    :is="tag"
    ref="innerRef"
    :type="!href ? type : undefined"
    :href="href"
    :class="[
      'cursor-pointer',
      $style.btn,
      small ? $style.small : $style.large,
      xsmall ? $style.xsmall : $style.large,
      light && $style.light,
      holo && $style.holo,
      borderless && $style.borderless,
      active && $style.active,
      secondary && !light && !holo && $style.secondary,
      !secondary && !light && !holo && $style.primary,
    ]"
  >
    <!-- @slot content of the button -->
    <slot />
  </component>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'

const props = withDefaults(
  defineProps<{
    type?: 'button' | 'submit' | 'reset'
    /**
     * small version of the button
     */
    small?: boolean
    xsmall?: boolean
    /**
     * alternative version of the button
     */
    secondary?: boolean
    light?: boolean
    borderless?: boolean
    active?: boolean
    href?: string
    holo?: boolean
  }>(),
  {
    type: 'button',
    href: '',
  },
)

const innerRef = ref<HTMLButtonElement | HTMLAnchorElement | null>(null)

const tag = computed(() => (props.href ? 'a' : 'button'))

const focusInner = () => {
  innerRef.value?.focus()
}

defineExpose({
  focus: focusInner,
})
</script>

<style lang="scss" module>
@use 'ui-button' as *;
</style>
